export const API_URL = "https://freelancer-api.orientaloutsourcing.in/"
export const Img_URL = "https://www.freelancer.com"
// export const API_URL = "http://localhost:5000/"